<div class="container-fluid edit-profile">





    <!--Personal Information -->

<div class="edit-my-profile-title">{{ 'PersonalInformation' | translate }}</div>

      <form class="row" name="form" [formGroup]="personalInfoForm" (ngSubmit)="personalInfoForm.valid && onSubmit()">
        <div class="col-lg-10 col-md-12">
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <!--Name-->
              <div class="form-group">
                <label class="mb-3">{{ 'FirstName' | translate }}</label>
                <div class="form-group">
                  <input placeholder="{{ 'FirstName' | translate }}" type="text" class="form-control"
                  formControlName="firstName" 
                  [ngClass]="{'is-invalid':personalInfoForm.get('firstName').touched && personalInfoForm.get('firstName').invalid}" />
                  <div *ngIf="personalInfoForm.get('firstName').touched && personalInfoForm.get('firstName').invalid" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('firstName').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                  </div>
                </div>
              </div>
              
              <div class="form-group">
                <label class="mb-3">{{ 'ThirdName' | translate }}</label>
                <div class="form-group">
                  <input placeholder="{{ 'ThirdName' | translate }}" type="text" class="form-control"
                  formControlName="thirdName" 
                  [ngClass]="{'is-invalid':personalInfoForm.get('thirdName').touched && personalInfoForm.get('thirdName').invalid}" />
                  <div *ngIf="personalInfoForm.get('thirdName').touched && personalInfoForm.get('thirdName').invalid" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('thirdName').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                  </div>
                </div>
              </div>
              
              <!--Gender-->
              <div class="form-group">
                <label class="mb-3">{{ 'Gender' | translate }}</label>
                <div class="form-group">
                  <mat-radio-group formControlName="gender" value="SecurityDeposit" id="gender">
                    <mat-radio-button class="mr-3" [value]="genderEnum.Male"
                      [ngClass]="{'is-invalid':personalInfoForm.get('gender').touched && personalInfoForm.get('gender').invalid}">
                      {{genderEnum[genderEnum.Male] +'' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="genderEnum.Female"
                      [ngClass]="{'is-invalid':personalInfoForm.get('gender').touched && personalInfoForm.get('gender').invalid}">
                      {{genderEnum[genderEnum.Female] +'' | translate}}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2"></div>
            <div class="col-lg-5 col-md-5">
              <div class="form-group">
                <label class="mb-3">{{ 'SecondName' | translate }}</label>
                <div class="form-group">
                  <input placeholder="{{ 'secondName' | translate }}" type="text" class="form-control"
                  formControlName="secondName" 
                  [ngClass]="{'is-invalid':personalInfoForm.get('secondName').touched && personalInfoForm.get('secondName').invalid}" />
                  <div *ngIf="personalInfoForm.get('secondName').touched && personalInfoForm.get('secondName').invalid" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('secondName').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="mb-3">{{ 'familyName' | translate }}</label>
                <div class="form-group">
                  <input placeholder="{{ 'familyName' | translate }}" type="text" class="form-control"
                  formControlName="familyName" 
                  [ngClass]="{'is-invalid':personalInfoForm.get('familyName').touched && personalInfoForm.get('familyName').invalid}" />
                  <div *ngIf="personalInfoForm.get('familyName').touched && personalInfoForm.get('familyName').invalid" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('familyName').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                  </div>
                </div>
              </div>
              <!--Email-->
              <div class="form-group">
                <label for="email"> {{ 'EmailAddress' | translate }}</label>
                <div>{{this.customerProfile.primaryEmail}}</div>
                
                <!-- <input disabled placeholder="{{ 'EmailAddress' | translate }}" type="text" class="form-control"
                  formControlName="email" (blur)="emilBlur($event)" id="email"
                  [ngClass]="{'is-invalid':personalInfoForm.get('email').touched && personalInfoForm.get('email').invalid}" />
                <div *ngIf="personalInfoForm.get('email').touched && personalInfoForm.get('email').invalid"
                  class="invalid-feedback">
                  <div *ngIf="personalInfoForm.get('email').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'EmailNameisrequired' | translate }}</div></div>
                  <div *ngIf="personalInfoForm.get('email').errors.email"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}</div></div>
                  <div
                    *ngIf="personalInfoForm.get('email').errors && personalInfoForm.get('email').errors.exist !=null">
                    {{ 'EmailAlreadyExist' | translate }}</div>
                </div> -->



              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 col-md-5">
              <!--Date of Birth-->
              <div class="form-group row">
                <label class="col-12">{{ 'DateofBirth' | translate }}</label>
                <div class="col-md-12">
                  <div class="form-date profile-date">
                    <mat-form-field appearance="none">
                        <mat-datepicker-toggle matPrefix [for]="DateofBirth"></mat-datepicker-toggle>
                        <mat-datepicker #DateofBirth></mat-datepicker>
                        <input  id="DateofBirth" readonly [max]="minDOB"  formControlName="DateofBirth" matInput  [matDatepicker]="DateofBirth" (click)="DateofBirth.open()"  [ngClass]="{'is-invalid':personalInfoForm.get('DateofBirth').touched && personalInfoForm.get('DateofBirth').invalid}" >
                    </mat-form-field>
                    <div *ngIf="isSubmitted&& personalInfoForm.get('DateofBirth').invalid"  class="invalid-feedback" [ngStyle]="{'display': personalInfoForm.get('DateofBirth').invalid ? 'block' : 'none' }">
                      <div *ngIf="personalInfoForm.get('DateofBirth').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                    </div>

                   
                  </div>

                </div>
              </div>



              
              <!--Nationalty -->

              <div class="form-group row">
                <label class="col-12">{{ 'Nationalty' | translate }}</label>
                <div class="col-md-12">

                  <!-- <mat-select panelClass="select-country" class="form-control select-control "
                  name="nationalty"
                    formControlName="nationalty"  [(ngModel)]="customerProfile.nationalityID" id="nationalty" [ngClass]="{'is-invalid':personalInfoForm.get('nationalty').touched&&personalInfoForm.get('nationalty').invalid}" required >

                    <mat-option *ngFor="let location of nationalities" [value]="location.locationID">
                      {{location.locationName}}
                    </mat-option>
                  </mat-select> -->

                  <mat-select panelClass="select-country" class="form-control select-control "
                  name="nationalty"
                    formControlName="nationalty"   id="nationalty" [ngClass]="{'is-invalid':personalInfoForm.get('nationalty').touched&&personalInfoForm.get('nationalty').invalid}" required >

                    <mat-option *ngFor="let location of nationalities" [value]="location.locationID">
                      {{location.locationName}}
                    </mat-option>
                  </mat-select>

                  <div *ngIf="isSubmitted && personalInfoForm.get('nationalty').invalid" class="invalid-feedback">
                    <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                  </div>



                </div>
              </div>

              <!--Occupation -->
              <div class="form-group row">
                <label class="col-12">{{ 'Occupation' | translate }}</label>
                <div class="col-md-12">
                  <mat-select panelClass="select-country" formControlName="occupation" id="occupation"
                  class="form-control select-control"
                  name="occupation"
                  [ngClass]="{'is-invalid':personalInfoForm.get('occupation').touched&&personalInfoForm.get('occupation').invalid}"  >

                  <mat-option *ngFor="let item of customerProfile.customerOccupations" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                  </mat-select>


                  <div *ngIf="isSubmitted&&personalInfoForm.get('occupation').invalid" class="invalid-feedback">
                    <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                  </div>



                </div>

              </div>


              <!--Work place -->
              <div class="form-group row">
                <label class="col-12">{{ 'WorkPlace' | translate }}</label>
                <div class="col-md-12">

                  <input placeholder="{{ 'WorkPlace' | translate }}" type="text" class="form-control"
                  formControlName="workPlace" id="workPlace"
                  [ngClass]="{'is-invalid':personalInfoForm.get('workPlace').touched && personalInfoForm.get('workPlace').invalid}" />
                  <div *ngIf="personalInfoForm.get('workPlace').touched && personalInfoForm.get('workPlace').invalid" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('workPlace').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                  </div>

                </div>
              </div>




            </div>
            <div class="col-lg-2 col-md-2"></div>
            <div class="col-lg-5 col-md-5">


              <!--Mobile Number -->
              <div class="form-group row">
                <label class="col-12">{{ 'MobileNumber' | translate }}</label>
                <div class="col-md-12">
                  <ngx-intl-tel-input [cssClass]="'form-control border-0'" [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
                    [tooltipField]="TooltipLabel.Name" [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    (countryChange)="mobileNumCountryCodeChanged()"
                    (keydown.space)="$event.preventDefault();"
                    [ngClass]="{'is-invalid':personalInfoForm.get('mobileNum').touched && personalInfoForm.get('mobileNum').invalid}"
                    name="mobileNum" formControlName="mobileNum" id="mobileNum">
                  </ngx-intl-tel-input>
                  <div *ngIf=" personalInfoForm.get('mobileNum').errors!=null" class="invalid-feedback">
                    <div *ngIf="personalInfoForm.get('mobileNum').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                    <div *ngIf="personalInfoForm.get('mobileNum').errors.validatePhoneNumber!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidMobileNumber' | translate }}</div></div>
                    <div *ngIf="personalInfoForm.get('mobileNum').errors.RequiredCountryCode!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RequiredCountryCode' | translate }}</div></div>
                    <div *ngIf="personalInfoForm.get('mobileNum').errors.InvalidSpace!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidSpace' | translate }}</div></div>
                  </div>
                </div>

              </div>

              <!--Country -->
              <div class="form-group row">
                <label class="col-12">{{ 'Country' | translate }}</label>
                <div class="col-md-12">
                  <!--  <input type="text" placeholder="country" formControlName="country" class="form-control"
                    [ngClass]="{'is-invalid':personalInfoForm.get('country').touched && personalInfoForm.get('country').invalid}" />
 -->
                  <div *ngIf="locationsRoot!=null">

                    <mat-select panelClass="select-country" formControlName="country" id="country"
                      class="form-control select-control " [(value)]="selectedRoot"
                      (selectionChange)="buildLocations($event.value)"
                      name="country"
                      [ngClass]="{'is-invalid':isSubmitted&&personalInfoForm.get('country')!=null&&personalInfoForm.get('country').invalid}" required >

                      <mat-option *ngFor="let location of locationsRoot" [value]="location">
                        {{location.locationName}}
                      </mat-option>
                    </mat-select>
                  </div>
<!--
                  <div *ngIf="personalInfoForm.get('country').touched&&personalInfoForm.get('country').invalid" class="invalid-feedback">
                    <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                   </div> -->

                   <!-- <div *ngIf="personalInfoForm.get('country')!=null&&personalInfoForm.get('country').touched" class="invalid-feedback">
                    <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                   </div> -->

                   <div *ngIf="isSubmitted&& personalInfoForm.get('country').errors?.required">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('country').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                    </div>
                  </div>





                </div>
              </div>

              <div *ngFor="let item of locationLevelsDropDown" class="form-group row">
                <label class="col-12">{{ item.nameResourceKey | translate }}</label>
                <div class="col-md-12">


                  <mat-select panelClass="select-country" class="form-control select-control "
                    [(value)]="selectedLevels[item.locationLevelID]"
                    [formControlName]="item.locationLevelID+''"
                    (selectionChange)="getLocationLevelDynamic($event.value)"
                    [ngClass]="{'is-invalid':isSubmitted&&personalInfoForm.get(item.locationLevelID+'')!=null&&personalInfoForm.get(item.locationLevelID+'').invalid}"  >
                    <mat-option *ngFor="let location of item.locationLevelData" [value]="location">
                      {{location.locationName}}
                    </mat-option>
                  </mat-select>

                  <div *ngIf=" isSubmitted && personalInfoForm.get(item.locationLevelID+'')!=null&&personalInfoForm.get(item.locationLevelID+'').invalid" class="invalid-feedback">
                    <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                  </div>






                </div>
              </div>



            </div>



          </div>

          <div class="row">
            <div class="col-md-12">
              <label class="mt-4">{{ 'Documents' | translate }}</label>

              <div class="edit-users table-responsive mat-elevation-z8">
                <table  class="table table-bordered customer-attachment mb-5">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ 'Type' | translate }}</th>
                      <th>{{ 'DocumentNumber' | translate }}</th>
                      <th>{{ 'IssueDate' | translate }}</th>
                      <th>{{ 'ExpiryDate' | translate }}</th>
                      <th class="border-right-0">{{ 'File' | translate }}</th>
                      <th class="border-left-0 "></th>
                      <!-- <th class="border-left-0 "></th> -->
                    </tr>
                  </thead>
                  <tr>
                    <td>{{ 'IDCard' | translate }}</td>
                    <td><input type="text" placeholder="{{ 'DocumentNumber' | translate }}" formControlName="idCard"
                        class="form-control" [ngClass]="{'is-invalid':personalInfoForm.get('idCard').touched && personalInfoForm.get('idCard').invalid}" />
                        <div *ngIf="isSubmitted&& personalInfoForm.get('idCard').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('idCard').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>
                      </td>
                    <td>
                      <div class="form-date">
                        <mat-form-field appearance="none">
                          <mat-datepicker-toggle matPrefix [for]="idCardIssueDate"></mat-datepicker-toggle>
                          <mat-datepicker #idCardIssueDate></mat-datepicker>
                          <input readonly placeholder="{{ 'IssueDate' | translate }}" formControlName="idCardIssueDate" matInput
                            [matDatepicker]="idCardIssueDate" (click)="idCardIssueDate.open()"
                            [ngClass]="{'is-invalid':personalInfoForm.get('idCardIssueDate').touched && personalInfoForm.get('idCardIssueDate').invalid}">
                        </mat-form-field>
                        <div *ngIf="isSubmitted&& personalInfoForm.get('idCardIssueDate').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('idCardIssueDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-date">
                        <mat-form-field appearance="none">
                          <mat-datepicker-toggle matPrefix [for]="idCardExpireDate"></mat-datepicker-toggle>
                          <mat-datepicker #idCardExpireDate></mat-datepicker>
                          <input readonly placeholder="{{ 'ExpiryDate' | translate }}" formControlName="idCardExpireDate" matInput
                            [min]="personalInfoForm.value.idCardIssueDate"
                            [matDatepicker]="idCardExpireDate" (click)="idCardExpireDate.open()"
                            [ngClass]="{'is-invalid':personalInfoForm.get('idCardExpireDate').touched && personalInfoForm.get('idCardExpireDate').invalid}">
                        </mat-form-field>

                      <div *ngIf="isSubmitted && personalInfoForm.value.idCardIssueDate > personalInfoForm.value.idCardExpireDate">
                          <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'TheExpiryDateShouldNotBeBeforeTheIssueDate' | translate }}</div>
                        </div>

                        <div *ngIf="isSubmitted&& personalInfoForm.get('idCardExpireDate').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('idCardExpireDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                      </div>
                    </td>
                    <td class="align-middle border-right-0 upload-files">
                      <div *ngIf="attachmentIds[idCardControlName]==null">
                        <a *ngIf="personalInfoForm.controls.idCardAttachmentLink!=null"
                          [href]="personalInfoForm.controls.idCardAttachmentLink.value"
                          download>{{personalInfoForm.controls.idCardFileName.value}}</a>
                        <span *ngIf="personalInfoForm.controls.idCardAttachmentLink==null">
                          {{ 'IDCard' | translate }}</span>
                      </div>
                      <a *ngIf="attachmentIds[idCardControlName]!=null"
                        [href]="attachmentIds[idCardControlName].attachmnetLink"
                        [download]="attachmentIds[idCardControlName].file.name">{{attachmentIds[idCardControlName].file.name}}</a>

                        <div *ngIf="isSubmitted&& personalInfoForm.get('idCardFileName').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('idCardFileName').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                      </td>
                    <!---->
                    <td class="align-middle border-left-0 ">
                      <!-- <mat-icon>cloud_upload</mat-icon> -->
                      <label class="Upload-icon mr-2" for="idCardFileInput">
                        <mat-icon>cloud_upload</mat-icon>
                        <!-- <div class="hover-text">Choose file</div>
                        <div class="background"></div> -->
                      </label>
                      <input id="idCardFileInput" type='file'
                        (change)="onSelectFile($event,attachmentScopesEnum.Customer,attachmentTypeEnum.IdintityCard,idCardControlName)"
                        style="display: none;" formControlName="idCardFileName" [ngClass]="{'is-invalid':personalInfoForm.get('idCardFileName').touched && personalInfoForm.get('idCardFileName').invalid}">

                    </td>

                  </tr>
                  <tr>
                    <td >{{ 'Passport' | translate }}</td>
                    <td ><input type="text" placeholder="{{ 'DocumentNumber' | translate }}" formControlName="passport"
                        class="form-control" [ngClass]="{'is-invalid':personalInfoForm.get('passport').touched && personalInfoForm.get('passport').invalid}">
                        <div *ngIf="isSubmitted&& personalInfoForm.get('passport').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('passport').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>


                      </td>
                        <td>
                          <div class="form-date">
                            <mat-form-field appearance="none">
                              <mat-datepicker-toggle matPrefix [for]="passportIssueDate"></mat-datepicker-toggle>
                              <mat-datepicker #passportIssueDate></mat-datepicker>
                              <input readonly placeholder="{{ 'IssueDate' | translate }}" formControlName="passportIssueDate" matInput
                                [matDatepicker]="passportIssueDate" (click)="passportIssueDate.open()"
                                [ngClass]="{'is-invalid':personalInfoForm.get('passportIssueDate').touched && personalInfoForm.get('passportIssueDate').invalid}">
                            </mat-form-field>
                            <div *ngIf="isSubmitted&& personalInfoForm.get('passportIssueDate').errors?.required">
                              <div class="validation-error">
                                <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('passportIssueDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                              </div>
                            </div>
                          </div>
                        </td>
                    <td>
                      <div class="form-date">
                        <mat-form-field appearance="none">
                          <mat-datepicker-toggle matPrefix [for]="passportExpireDate"></mat-datepicker-toggle>
                          <mat-datepicker #passportExpireDate></mat-datepicker>
                          <input readonly placeholder="{{ 'ExpiryDate' | translate }}" formControlName="passportExpireDate" matInput
                            [min]="personalInfoForm.value.passportIssueDate"
                            [matDatepicker]="passportExpireDate" (click)="passportExpireDate.open()"
                            [ngClass]="{'is-invalid':personalInfoForm.get('passportExpireDate').touched && personalInfoForm.get('passportExpireDate').invalid}">
                        </mat-form-field>
                        <div *ngIf="isSubmitted&& personalInfoForm.get('passportExpireDate').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('passportExpireDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                        <div *ngIf="isSubmitted && personalInfoForm.value.passportIssueDate > personalInfoForm.value.passportExpireDate">
                          <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'TheExpiryDateShouldNotBeBeforeTheIssueDate' | translate }}</div>
                        </div>

                      </div>
                    </td>
                    <!--   <td class="align-middle border-right-0">{{ 'Passport' | translate }}</td>
                    <td class="align-middle border-left-0 border-right-0">
                      <mat-icon>cloud_upload</mat-icon>
                    </td> -->
                    <!--Heree-->
                    <td class="align-middle border-right-0 upload-files">
                      <div *ngIf="attachmentIds[passportControlName]==null">
                        <a *ngIf="personalInfoForm.controls.passportAttachmentLink!=null"
                          [href]="personalInfoForm.controls.passportAttachmentLink.value"
                          download>{{personalInfoForm.controls.passportFileName.value}}</a>
                        <span *ngIf="personalInfoForm.controls.passportAttachmentLink==null">
                          {{ 'Passport' | translate }}</span>
                      </div>
                      <a *ngIf="attachmentIds[passportControlName]!=null"
                        [href]="attachmentIds[passportControlName].attachmnetLink"
                        [download]="attachmentIds[passportControlName].file.name">{{attachmentIds[passportControlName].file.name}}</a>
                        <div *ngIf="isSubmitted&& personalInfoForm.get('passportFileName').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('passportFileName').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                      </td>
                    <!---->
                    <td class="align-middle border-left-0 ">
                      <!-- <mat-icon>cloud_upload</mat-icon> -->
                      <label class="Upload-icon mr-2"  for="passportFileInput">
                        <mat-icon>cloud_upload</mat-icon>
                        <!-- <div class="hover-text">Choose file</div>
                              <div class="background"></div> -->
                      </label>
                      <input id="passportFileInput" type='file'
                        (change)="onSelectFile($event,attachmentScopesEnum.Customer,attachmentTypeEnum.Passport,passportControlName)"
                        style="display: none;" formControlName="passportFileName" [ngClass]="{'is-invalid':personalInfoForm.get('passportFileName').touched && personalInfoForm.get('passportFileName').invalid}">


                    </td>
                    <!--Stop-->

                  </tr>
                  <tr>
                    <td >{{ 'DrivingLicense' | translate }}</td>
                    <td ><input type="text" placeholder="{{ 'DocumentNumber' | translate }}" formControlName="drivingLicense"
                        class="form-control" [ngClass]="{'is-invalid':personalInfoForm.get('drivingLicense').touched && personalInfoForm.get('drivingLicense').invalid}">

                        <div *ngIf="isSubmitted&& personalInfoForm.get('drivingLicense').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('drivingLicense').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>
                      </td>
                        <td>
                          <div class="form-date">
                            <mat-form-field appearance="none">
                              <mat-datepicker-toggle matPrefix [for]="drivingLicenseIssueDate"></mat-datepicker-toggle>
                              <mat-datepicker #drivingLicenseIssueDate></mat-datepicker>
                              <input readonly placeholder="{{ 'IssueDate' | translate }}" formControlName="drivingLicenseIssueDate" matInput
                                [matDatepicker]="drivingLicenseIssueDate" (click)="drivingLicenseIssueDate.open()"
                                [ngClass]="{'is-invalid':personalInfoForm.get('drivingLicenseIssueDate').touched && personalInfoForm.get('drivingLicenseIssueDate').invalid}">
                            </mat-form-field>
                            <div *ngIf="isSubmitted&& personalInfoForm.get('drivingLicenseIssueDate').errors?.required">
                              <div class="validation-error">
                                <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('drivingLicenseIssueDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                              </div>
                            </div>
                          </div>
                        </td>
                    <td>
                      <div class="form-date">
                        <mat-form-field appearance="none">
                          <mat-datepicker-toggle matPrefix [for]="drivingLicenseExpireDate"></mat-datepicker-toggle>
                          <mat-datepicker #drivingLicenseExpireDate></mat-datepicker>
                          <input readonly placeholder="{{ 'ExpiryDate' | translate }}" formControlName="drivingLicenseExpireDate" matInput
                          [min]="personalInfoForm.value.drivingLicenseIssueDate"
                              [matDatepicker]="drivingLicenseExpireDate" (click)="drivingLicenseExpireDate.open()"
                            [ngClass]="{'is-invalid':personalInfoForm.get('drivingLicenseExpireDate').touched && personalInfoForm.get('drivingLicenseExpireDate').invalid}">
                        </mat-form-field>
                        <div *ngIf="isSubmitted&& personalInfoForm.get('drivingLicenseExpireDate').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('drivingLicenseExpireDate').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                        <div *ngIf="isSubmitted && personalInfoForm.value.drivingLicenseIssueDate > personalInfoForm.value.drivingLicenseExpireDate">
                          <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'TheExpiryDateShouldNotBeBeforeTheIssueDate' | translate }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle border-right-0 upload-files">
                      <div *ngIf="attachmentIds[driverLincesControlName]==null">
                        <a *ngIf="personalInfoForm.controls.drivingLicenseAttachmentLink!=null"
                          [href]="personalInfoForm.controls.drivingLicenseAttachmentLink.value"
                          download>{{personalInfoForm.controls.drivingLicenseFileName.value}}</a>
                        <span *ngIf="personalInfoForm.controls.drivingLicenseAttachmentLink==null">
                          {{ 'DrivingLicense' | translate }}</span>
                      </div>
                      <a *ngIf="attachmentIds[driverLincesControlName]!=null"
                        [href]="attachmentIds[driverLincesControlName].attachmnetLink"
                        [download]="attachmentIds[driverLincesControlName].file.name">{{attachmentIds[driverLincesControlName].file.name}}</a>
                        <div *ngIf="isSubmitted&& personalInfoForm.get('drivingLicenseFileName').errors?.required">
                          <div class="validation-error">
                            <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="personalInfoForm.get('drivingLicenseFileName').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                          </div>
                        </div>

                      </td>
                    <td class="align-middle border-left-0">
                      <!-- <mat-icon>cloud_upload</mat-icon> -->
                      <label class="Upload-icon mr-2"  for="driverLincesFileInput">
                        <mat-icon>cloud_upload</mat-icon>
                        <!-- <div class="hover-text">Choose file</div>
                        <div class="background"></div> -->
                      </label>
                      <input id="driverLincesFileInput" type='file'
                        (change)="onSelectFile($event,attachmentScopesEnum.Customer,attachmentTypeEnum.DrivingLicense,driverLincesControlName)"
                        style="display: none;" formControlName="drivingLicenseFileName" [ngClass]="{'is-invalid':personalInfoForm.get('drivingLicenseFileName').touched && personalInfoForm.get('drivingLicenseFileName').invalid}">


                    </td>
                    <!--   <td class="align-middle border-right-0">{{ 'DrivingLicense' | translate }}</td>
                    <td class="align-middle border-left-0 border-right-0">
                      <mat-icon>cloud_upload</mat-icon>
                    </td> -->

                  </tr>
                </table>
              </div>

              <div class="form-group mt-4 mb-4">
                <button class="btn default-btn mr-3" (click)="save()">{{ 'Save' | translate }}</button>
                <button class="btn  default-cancel-btn" type="reset" (click)="onReset()">{{ 'Cancel' | translate }}</button>
              </div>
            </div>
          </div>


        </div>
      </form>


    <!--Billing Information
    <mat-tab class="mt-0" label="{{ 'BillingInformation' | translate }}">
      <payment class="mt-0"></payment>
    </mat-tab> -->




</div>
